import { PuzzleMark } from "@/components/puzzle/PuzzleMark";
import { MicroLabel } from "@/components/decor/CropMarks";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      style={{ background: "#0A0A0A", borderTop: "1px solid rgba(192,192,192,0.15)" }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <PuzzleMark size={44} animated={false} />
              <div
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: 900,
                  letterSpacing: "0.18em",
                  fontSize: 14,
                  color: "#F5F1E8",
                }}
              >
                KRISTER OVERSEAS
              </div>
            </div>
            <p
              style={{
                color: "#C0C0C0",
                fontSize: 14,
                lineHeight: 1.7,
                maxWidth: 380,
              }}
            >
              Branding Beyond Boundaries. From Print to Presence. From Products to
              Identity.
            </p>
          </div>

          <div className="md:col-span-3">
            <MicroLabel index={1} accent="#B89B5E">
              Contact
            </MicroLabel>
            <ul className="mt-5 space-y-3" style={{ color: "#C0C0C0", fontSize: 13 }}>
              <li>
                <a
                  href="mailto:contact@kristeroverseas.com"
                  className="hover:text-[#F5F1E8] transition-colors"
                  data-testid="footer-email"
                >
                  contact@kristeroverseas.com
                </a>
              </li>
              <li data-testid="footer-phone">+91 98100 80821 · +91 93100 80821</li>
              <li data-testid="footer-address">Delhi, India</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <MicroLabel index={2} accent="#B89B5E">
              Capabilities
            </MicroLabel>
            <ul
              className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2"
              style={{ color: "#C0C0C0", fontSize: 13 }}
            >
              <li>Print Media</li>
              <li>Corporate Gifting</li>
              <li>Brand Visibility</li>
              <li>Promotional Products</li>
              <li>Signage &amp; Display</li>
              <li>Brand Development</li>
            </ul>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(192,192,192,0.12)" }}
        >
          <div className="ko-overline" style={{ color: "#C0C0C0" }}>
            © {year} Krister Overseas · All rights reserved
          </div>
          <div className="flex items-center gap-3">
            <span
              aria-hidden
              style={{ width: 10, height: 10, background: "#0072CE" }}
            />
            <span
              aria-hidden
              style={{ width: 10, height: 10, background: "#D6007F" }}
            />
            <span
              aria-hidden
              style={{ width: 10, height: 10, background: "#FFD200" }}
            />
            <span
              aria-hidden
              style={{
                width: 10,
                height: 10,
                background: "#0A0A0A",
                border: "1px solid #C0C0C0",
              }}
            />
            <span className="ko-overline" style={{ color: "#C0C0C0" }}>
              CMYK · K
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
